// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3T1k0","list":"styles_list__3e9cY"};